import constants from "../../../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter} from '@dataGrid/components/columnFilters';
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
export default class GridConfig {
  constructor() {
    this.name = "GridConfiguration";
    this.config = GridConfig.getDefaultConfiguration();
  }

  static ShowDateTimeInTerminalTimeZone(params) {
    if (params && params.value) {
      return format(
        utcToZonedTime(params.value, params.context.terminalOffset),
        constants.DATETYPES.DATETIME.format
      );
    }
    return "";
  }

  static getDefaultConfiguration() {
    return {
      title: constants.gridNames.DispatchGroupMsg,
      keyColumn: "time",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        lockPosition: true,
      },
      columns: [
        {
          headerName: "Time",
          field: "createdDateTime",
          width: constants.columnWidth.DISPATCH_GROUP_MSG_TIME,
          minWidth: constants.columnWidth.DISPATCH_GROUP_MSG_TIME,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME,
          },
          valueFormatter: GridConfig.ShowDateTimeInTerminalTimeZone,
        },
        {
          headerName: "From",
          headerTooltip: "Dispatcher",
          field: "dispatcher",
          width: constants.columnWidth.DISPATCH_GROUP_MSG_FROM,
          minWidth: constants.columnWidth.DISPATCH_GROUP_MSG_FROM,
          filter: MultiSelectFilter,
          tooltipField: "dispatcher",
        },
        {
          headerName: "To",
          headerTooltip: "Drivers",
          field: "driverIds",
          width: constants.columnWidth.DISPATCH_GROUP_MSG_TO,
          minWidth: constants.columnWidth.DISPATCH_GROUP_MSG_TO,
          filter: MultiSelectFilter,
          tooltipField: "driverIds",
        },
        {
          headerName: "Message",
          field: "message",
          width: constants.columnWidth.DISPATCH_GROUP_MSG_MESSAGE,
          minWidth: constants.columnWidth.DISPATCH_GROUP_MSG_MESSAGE,
          filter: MultiSelectFilter,
          tooltipField: "message",
        }
      ],
    };
  }
}
